export default "__VITE_ASSET__D$gUbT85__"